<template>
  <div class="page">
    <div class="group_1" v-if="examList.length !== 0">
      <div class="box_1" v-for="item in examList" :key="item.id">
        <div class="title">{{item.name}}</div>
        <van-divider />
        <div class="box_2">
          <div class="count"></div>
          <div class="box_3">
            <div class="price">
              <span style="font-size: 12px;" v-if="item.price > 0">￥</span>
              <span v-if="item.price > 0">{{ item.price.toFixed(2) }}</span>
              <span v-else>免费</span>
            </div>
            <div class="btn" v-if="item.price == 0 || item.isBuy == 1"  @click="goExam(item)">立即练习</div>
            <!-- <div class="btn" v-else @click="isBuy(item)">购买</div> -->
          </div>
        </div>
      </div>
    </div>

    <van-empty description="暂无数据" v-if="examList.length == 0"/>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toMockExamList,toGenerateOrderByMockId } from '@/api/exam'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examList:[],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //购买考试
    isBuy(item) {
      console.log(item);
      toGenerateOrderByMockId({derateType:'02',mockId:item.id}).then(res => {
        console.log(res);
        
      })
    },
    //
    toMockExamList() {
      toMockExamList({examName:''}).then(res => {
        this.examList = res.data.data.mockList
      })
    },
    //去考试页面
    goExam(item) {
      console.log(item);
      this.$router.push({
        path:'/exam',
        query:{
          id:item.id
        }
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.toMockExamList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page { 
 margin-top: 46px;
}
.group_1 {
  padding: 10px 15px;
}
.box_1 {
  margin-bottom: 10px;
  // width: 345px;
  padding: 20px 15px;
  height: 118px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 300px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
  .box_2 {
    display: flex;
    justify-content: space-between;
    .count {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
    }
    .box_3 {
      display: flex;
      align-items: center;
    }
    .price {
      color: #ff2d31;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 17px;
    }
    .btn {
      width: 76px;
      height: 32px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      border-radius: 16px 16px 16px 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      margin-left: 20px;
    }
  }
}
</style>
